import { type LinkedVariantAggregateCountsDto } from "@lib/ShiOneClient";
import { itProjectsVariantsClient } from "./itProjectsLinkedVariantsClient";

export function fetchLinkedVariantAggregateCounts(
    projectId: string,
): Promise<LinkedVariantAggregateCountsDto> {
    return itProjectsVariantsClient.getLinkedVariantAggregateCounts(projectId);
}
